import {notificationState} from '../state/notificationState';
import {Fetch_All_Notification_Data, Fetch_Count,Handle_Notifi_Error} from '../actions/notificationAction';

export function NotificationReducer(state = notificationState, action) {
    switch(action.type){
        case Fetch_All_Notification_Data:
            return Object.assign({}, state, {
                message : action.message,
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                notificationList : action.list,
                count : action.countValue
            })
        case Fetch_Count:
            return Object.assign({}, state, {
                count : action.count
            })
        case Handle_Notifi_Error:
            return Object.assign({}, state,{
                errorCode : action.errorCode,
                message : action.errorMessage,
                statusCode : action.statusCode
            })
        default:
            return state
    }
}